/**
 * Point d'entree React de l'application portfolio.
 *
 * Role : premier code execute quand le navigateur charge la page. Monte le
 * composant racine `<App />` dans la div `#root` de `public/index.html`.
 *
 * Pourquoi `ReactDOM.createRoot` (et pas `ReactDOM.render`) :
 * Depuis React 18, `createRoot` est obligatoire pour beneficier du rendu
 * concurrent (Suspense, batching automatique, transitions). L'ancien
 * `ReactDOM.render` est deprecate et n'active pas ces fonctionnalites.
 *
 * `React.StrictMode` : wrapper de dev qui detecte les patterns problematiques
 * (side-effects impurs, deprecations, etc.). Retire silencieusement les
 * warnings en prod, aucun impact runtime.
 *
 * `reportWebVitals()` : mesure les Web Vitals (CLS, FID, LCP) pour monitoring
 * perf. Voir `reportWebVitals.ts` pour le detail (actuellement no-op sans
 * handler passe en argument).
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
